import DTSTAMP from './DTSTAMP'

/**
 * CREATED property.
 *
 * @see https://tools.ietf.org/html/rfc5545#section-3.8.7.1
 */
export class CREATED extends DTSTAMP {
  static propName = 'CREATED'
}



// WEBPACK FOOTER //
// ./src/properties/CREATED.js